import { opaccAjaxPlugin } from '../opacc.static.js';
import { basketMessages } from '../messages/opacc.messages.js';
import { OpaccBasket } from './opacc.class.basket.js';

/** @module basket */

/**
 * Schnellerfassung funktionalität
 *
 * @extends {OpaccBasket}
 */
export class OpaccBasketQuickOrder extends OpaccBasket  {
    constructor() {
        super();
        this.initBasketQuickOrder();
    }

    /**
     *
     */
    initBasketQuickOrder() {
        this.doneTypingInterval = 750;
        this.inputSelector = 'input[data-op-quickorder="input"]';
        this.quickorder = document.querySelector('.opc-basket-list-quickorder');

        if (this.quickorder) {
            this.input = this.quickorder.querySelector(this.inputSelector);
            this.resultDropdown = document.querySelector('#quickorder-dropdown');

            if (this.input) {
                this.minLength = this.input.dataset.opMinlength;
                this.doneTyping(this.doneTypingInterval, this.input);
            }

            document.addEventListener('click', e => {
                if (e.target.closest('#quickorder-dropdown') != this.resultDropdown) {
                    this.resultDropdown.classList.remove('is-showing');
                }
                if (e.target == this.input) {
                    if (this.resultDropdown && !this.resultDropdown.classList.contains('is-showing')) {
                        this.resultDropdown.classList.add('is-showing');
                    }
                }
            });
        }
    }

    /**
     *
     */
    getSuggest() {
        if (this.input.value && this.input.value.trim().length >= +this.minLength) {
            let url = this.quickorder.getAttribute('data-op-url-search');
            let searchTerm = this.input.value;
            let data = {
                query: searchTerm
            }

            if (url && searchTerm) {
                this.resultDropdown.innerHTML = '';
                this.resultDropdown.classList.add('is-loading');
                opaccAjaxPlugin.fetchAsynPostForm(url, data, this.showResultInDropdown.bind(this));
            }
        } else {
            let msgTextNode = document.createTextNode( basketMessages.quickOrderMessageTooShort.text.replace('%1', +this.minLength) );
			let msgElem = document.createElement('div');
			msgElem.setAttribute('class', 'opc-quickorder-message');
			msgElem.dataset.opType = 'info';
			msgElem.appendChild( msgTextNode );

            this.resultDropdown.innerHTML = msgElem.outerHTML;
            this.resultDropdown.classList.add('is-showing');
        }
    }

    /**
     *
     * @param {*} response
     */
    showResultInDropdown(response) {
        this.resultDropdown.innerHTML = response;
        this.resultDropdown.classList.remove('is-loading');
        this.resultDropdown.classList.add('is-showing');

        let searchResult = document.querySelector('#quickorder-search-result');

        let liSelected = undefined;
        let liSelectedInput = undefined;
        let listElements = searchResult.querySelectorAll('li');
        let basketBtnQuantitySelector = 'input.basket-button-quantity';
        if(listElements.length > 0) {
            this.input.addEventListener('keyup', e => {
                if (e.keyCode === 40) {
                    // page down
                    liSelected = listElements[0];
                    liSelectedInput = liSelected.querySelector(basketBtnQuantitySelector);
                    if(liSelectedInput) {
                        liSelectedInput.focus();
                        liSelectedInput.select();
                    }
                } else if (e.keyCode === 13 && listElements.length === 1) {
                    liSelected = listElements[0];
                    this.triggerBasketAction(liSelected);
                }
            });
        }

        Array.from(listElements).forEach(item => {
            item.addEventListener('keyup', e => {
                if (e.keyCode === 40) {
                    // page down
                    if (liSelected) {
                        let next = liSelected.nextSibling;
                        liSelected = next !== undefined && next !== null ? next : liSelected;
                    } else {
                        liSelected = listElements[0];
                    }

                    liSelectedInput = liSelected.querySelector(basketBtnQuantitySelector);
                    if(liSelectedInput) {
                        liSelectedInput.focus();
                        liSelectedInput.select();
                    }
                    e.preventDefault();
                } else if (e.keyCode === 38) {
                    // page up
                    if (liSelected) {
                        let next = liSelected.previousSibling;
                        liSelected = next !== undefined && next !== null ? next : this.selectSearchInput();
                    } else {
                        liSelected = listElements[0];
                    }

                    if(liSelected) {
                        liSelectedInput = liSelected.querySelector(basketBtnQuantitySelector);
                        if(liSelectedInput) {
                            liSelectedInput.focus();
                            liSelectedInput.select();
                        }
                    }

                    e.preventDefault();
                } else if (e.keyCode === 13) {
                    // enter
                    if (e.currentTarget) {
                        this.triggerBasketAction(e.currentTarget);
                    }
                }
            });
        });
    }

    /**
     *
     */
    selectSearchInput() {
        this.input.focus();
        this.input.select();
    }

    /**
     *
     * @param {*} target
     */
    triggerBasketAction(target) {
        if (target) {
            let basketButton = target.querySelector('.list-item-basket-action .opc-button');
            if (basketButton) {
                basketButton.click();
                this.selectSearchInput();
            }
        }
    }

    /**
     *
     * @param {*} interval
     * @param {*} selector
     */
    doneTyping(interval, selector) {
        let typingTimer;
        let doneTypingInterval = interval;
        let searchTerm = undefined;

        selector.addEventListener('input', () => {
            clearTimeout(typingTimer);
            if (selector.value && selector.value != searchTerm) {
                searchTerm = selector.value;
                typingTimer = setTimeout(this.getSuggest.bind(this), doneTypingInterval);
            }
        });
    }
}